import { createElement } from 'react';
import { Table } from '@alifd/next';
import './index.scss';
const OadpTableColumn = function OadpTableColumn({ dataIndex, title, htmlTitle, width, alignHeader, align, lock, wordBreak, cell, ...otherProps }) {
    return (createElement(Table.Column, Object.assign({ dataIndex: dataIndex, title: title, htmlTitle: htmlTitle, width: width, alignHeader: alignHeader, align: align, lock: lock, wordBreak: wordBreak, cell: cell }, otherProps)));
};
export default OadpTableColumn;
